import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ViewStack = () => {
  const inner = document.querySelector('.p-homeView__inner');
  if (!inner) return;

  const imgFrames = inner.querySelectorAll('.p-homeView__imgFrame');
  if (imgFrames.length < 2) return;

  // SP では何もしない
  if (window.innerWidth < 768) return;

  const deckImg = imgFrames[0];
  const corridorImg = imgFrames[1];

  // 天望回廊の imgFrame を最初は非表示
  gsap.set(corridorImg, { opacity: 0, pointerEvents: 'none' });
  gsap.set(deckImg, { zIndex: 1 });
  gsap.set(corridorImg, { zIndex: 2 });

  // 2番目の textFrame をトリガーにクロスフェード
  const textFrames = inner.querySelectorAll('.p-homeView__textFrame');
  if (textFrames.length < 2) return;

  const corridorText = textFrames[1];

  ScrollTrigger.create({
    trigger: corridorText,
    start: 'top 80%',
    end: 'top 20%',
    scrub: true,
    onUpdate: (self) => {
      const p = self.progress;
      gsap.set(corridorImg, {
        opacity: p,
        pointerEvents: p > 0.5 ? 'auto' : 'none',
      });
      gsap.set(deckImg, {
        opacity: 1 - p,
        pointerEvents: p > 0.5 ? 'none' : 'auto',
      });
    },
  });
};

export default ViewStack;
